import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seal } from "../components/Chrome";

export default function NotFoundPage() {
  return (
    <section className="bg-paper py-24 lg:py-32" data-testid="not-found-page">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6">
        <Seal className="mx-auto h-16 w-16 rotate-3 text-2xl" />
        <p className="mt-8 font-display text-6xl font-bold tracking-tight text-ink sm:text-7xl">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-ink">Halaman tidak ditemukan</h1>
        <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-sumi">
          Sepertinya hidangan yang Anda cari tidak ada di meja kami. Kembali ke beranda atau lihat menu Umaku Sushi.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center gap-2 bg-ink px-6 py-3.5 text-sm font-bold text-paper transition-colors hover:bg-hanko"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Kembali ke Beranda
          </Link>
          <Link
            to="/menu/"
            data-testid="not-found-menu-link"
            className="inline-flex items-center gap-2 border-2 border-ink px-6 py-3 text-sm font-bold text-ink transition-colors hover:bg-ink hover:text-paper"
          >
            Lihat Menu
          </Link>
        </div>
      </div>
    </section>
  );
}
